<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: "EmptyPage"
  }
</script>

<style scoped>

</style>
